if (!customElements.get('size-guide-modal')) {
  customElements.define('size-guide-modal', class SizeGuideModal extends HTMLElement {
    constructor() {
      super();
      this.onClose = this.close.bind(this);
      this.onKeydown = this.keydown.bind(this);
    }

    connectedCallback() {
      // Append to document.body to break out of parent container transforms/stacking contexts
      if (!this.moved) {
        this.moved = true;
        document.body.appendChild(this);
      }

      // Find all buttons that trigger this modal
      const openers = document.querySelectorAll(`[aria-controls="${this.id}"]`);
      openers.forEach(opener => {
        opener.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(opener);
        });
      });

      // Find all close elements inside this modal
      this.querySelectorAll('[data-size-guide-close]').forEach(element => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          this.close();
        });
      });

      // Prevent clicks inside content box from closing modal
      const content = this.querySelector('.size-guide-modal__content');
      if (content) {
        content.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      }
    }

    open(opener) {
      this.openedBy = opener;
      this.removeAttribute('hidden');
      
      const bodyEl = this.querySelector('.size-guide-modal__body');
      if (bodyEl) {
        bodyEl.scrollTop = 0;
      }

      // Force frame update for CSS transition
      requestAnimationFrame(() => {
        this.classList.add('is-active');
      });

      document.body.classList.add('overflow-hidden', 'size-guide-modal-open');
      document.addEventListener('keydown', this.onKeydown);

      if (opener) {
        opener.setAttribute('aria-expanded', 'true');
      }

      // Focus close button for accessibility
      const closeBtn = this.querySelector('.size-guide-modal__close');
      if (closeBtn) {
        closeBtn.focus();
      }
    }

    close() {
      this.classList.remove('is-active');
      document.body.classList.remove('overflow-hidden', 'size-guide-modal-open');
      document.removeEventListener('keydown', this.onKeydown);

      if (this.openedBy) {
        this.openedBy.setAttribute('aria-expanded', 'false');
        try {
          this.openedBy.focus();
        } catch (e) {}
      }

      setTimeout(() => {
        this.setAttribute('hidden', '');
      }, 300);
    }

    keydown(event) {
      if (event.key === 'Escape' || event.code === 'Escape') {
        this.close();
      }
    }
  });
}
